var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('textarea',{class:'textareaCkeditor ' + _vm.class_required,attrs:{"tag-name":"textarea","id":this.textarea_id,"name":_vm.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }